import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ContentColumnizer from './ContentColumnizer';
import VehicleCards from './VehicleCards';
import SearchLinks from './SearchLinks';
import NoResults from './NoResults';
import RichContent from './richContent/RichContent';
import { ResultsContext } from '../contexts';

const InventoryStandard = ({
	vehicles,
	suggestions,
	shouldRenderNoResults,
	hasRichContentToDisplay
}) => {
	const { noResultsLinks, pageSearchResults } = useContext(ResultsContext);

	return (
		<ContentColumnizer vehicles={vehicles?.length > 0}>
			{vehicles?.length > 0 && <VehicleCards vehicles={vehicles} />}
			{suggestions?.length > 0 && (
				<SearchLinks type="inventory" data={suggestions} />
			)}
			{pageSearchResults?.length > 0 && (
				<SearchLinks type="page" data={pageSearchResults} />
			)}
			{shouldRenderNoResults && (
				<>
					<NoResults />
					<SearchLinks type="no-results" data={noResultsLinks} />
				</>
			)}
			{(hasRichContentToDisplay || shouldRenderNoResults) && (
				<RichContent />
			)}
		</ContentColumnizer>
	);
};

InventoryStandard.propTypes = {
	// eslint-disable-next-line react/forbid-prop-types
	vehicles: PropTypes.array,
	// eslint-disable-next-line react/forbid-prop-types
	suggestions: PropTypes.array,
	shouldRenderNoResults: PropTypes.bool,
	hasRichContentToDisplay: PropTypes.bool
};

export default React.memo(InventoryStandard);
